







import Vue from "vue";

export default Vue.extend({
    name: "KeyboardKey",
    props: {
        inputKey: {
            type: String,
            required: false
        },
        keyValue: {
            type: String,
            required: false
        }
    },
    methods: {
        keyPressed(): void {
            window.dispatchEvent(
                new KeyboardEvent("keydown", {
                    key: this.keyValue ? this.keyValue : this.inputKey,
                })
            );
        }
    }
})



